import { RootState } from '@reducers';

export const selectHealthClaim = (state: RootState) => state.userDashboardRouteReducer.claimDetails.healthClaimDetails;
